export const useIsUnitedStatesCitizen = (): boolean => {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // All US timezones
    const usTimezones = [
      // Continental US - Eastern Time
      'America/New_York',
      'America/Detroit',
      'America/Louisville',
      'America/Kentucky/Monticello',
      'America/Indiana/Indianapolis',
      'America/Indianapolis',
      'America/Indiana/Marengo',
      'America/Indiana/Petersburg',
      'America/Indiana/Vevay',
      'America/Indiana/Vincennes',
      'America/Indiana/Winamac',

      // Continental US - Central Time
      'America/Chicago',
      'America/Indiana/Knox',
      'America/Indiana/Tell_City',
      'America/Menominee',
      'America/North_Dakota/Beulah',
      'America/North_Dakota/Center',
      'America/North_Dakota/New_Salem',

      // Continental US - Mountain Time
      'America/Denver',
      'America/Boise',
      'America/Phoenix',

      // Continental US - Pacific Time
      'America/Los_Angeles',

      // Alaska
      'America/Anchorage',
      'America/Adak',
      'America/Juneau',
      'America/Metlakatla',
      'America/Nome',
      'America/Sitka',
      'America/Yakutat',

      // Hawaii
      'Pacific/Honolulu',

      // Territories
      'America/Puerto_Rico',
      'America/St_Thomas',
      'Pacific/Guam',
      'Pacific/Saipan',
      'Pacific/Pago_Pago',
      'Pacific/Midway',
      'Pacific/Wake',
    ];

    return usTimezones.includes(timezone);
  } catch {
    return false;
  }
};
